/* jshint esversion: 6 */
import React from 'react';

class PostListUtilities {
    static generateListComment(item, repost) {
        let comment = null,
            urlReg = /(\b((https?|ftp|file:\/\/)|www[.])[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;

        if (item.preview.comment || item.preview.message) {
            let content = item.preview.comment ? item.preview.comment : item.preview.message;
            comment = (
                <div>
                    <div className="post-preview-comment ellipsis">
                        {content} <span className="item-link">
                            <a href={item.preview.link} target="_blank">{item.preview.link}</a>
                        </span>
                    </div>
                </div>
            );
        } else if (item.preview.itemInfo) {
            let content = item.preview.itemInfo.body ? item.preview.itemInfo.body : item.preview.itemInfo.summary;
            comment = (
                <div>
                    <div className="post-preview-comment ellipsis">
                        {content} <span className="item-link">
                            <a href={item.preview.link} target="_blank">{item.preview.link}</a>
                        </span>
                    </div>
                </div>
            );
        } else if (item.preview.status) {
            let status = item.preview.status,
                statusComponent = [item.preview.status];

            status.split(urlReg).reduce(function(acc, val) {
                if (acc) {
                    statusComponent = (
                        <span>
                            {acc}
                            <span className="item-link">
                                {val}
                            </span>
                        </span>
                    );
                }
            });

            comment = <div className="post-preview-status item-user-content ellipsis">{repost}{statusComponent}</div>;

        }

        return comment;
    }

    static getPostType(item, props) {
		let postTypes = {},
			constants = props.app.config.constants,
            _postTypes = {
            	status: 'status',
            	link: 'link',
            	media: 'media'
            };

		postTypes[constants.PREVIEW_STATUS] = _postTypes.status;
		postTypes[constants.PREVIEW_SHARED] = _postTypes.link;
		postTypes[constants.PREVIEW_BLOG] = _postTypes.link;

        if (item.preview.mb_id) {
            if (item.preview.media && item.preview.media.length && item.preview.media[0].mimeType === 'video/mp4') {
                return 'video';
            } else {
                return 'media';
            }
        }

		return postTypes[item.preview.type];

	}
}

export default PostListUtilities;
